export const limit = 10;
